import { ONE_WAY, ROUND_TRIP } from "../constants.js";
import { buildOWPricedCalendarRequest, buildRTPricedCalendarRequest } from "../helper/helper.js";
import { handleRequest } from "./helpers/handleRequest.js";
import { shouldDisplayOW } from "./helpers/shouldDisplayOW.js";
function getPricingData({ displayMonths, flightDetails, pricePromise, variantName, departDate, getGraphURL, apolloClientInfo }) {
    let retailRequest = null;
    if (flightDetails?.tripType === ONE_WAY || shouldDisplayOW({
        departDate,
        flightDetails
    })) retailRequest = buildOWPricedCalendarRequest({
        tripDetails: flightDetails,
        displayMonths
    });
    if (flightDetails?.tripType === ROUND_TRIP && departDate) retailRequest = buildRTPricedCalendarRequest({
        tripDetails: flightDetails,
        displayMonths,
        departDate
    });
    if (!retailRequest) return Promise.resolve(null);
    return handleRequest({
        retailRequest,
        variantName,
        pricePromise,
        getGraphURL,
        apolloClientInfo
    });
}
export { getPricingData };
